"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerHooksAndNotifiers = void 0;
exports.registerHooksAndNotifiers = function (caller, settings, hooks, notifiers) {
    for (var key in hooks)
        settings.registerHook(key, hooks[key].bind(caller));
    for (var key in notifiers)
        settings.registerNotifier(key, notifiers[key].bind(caller));
};
